import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ChildPropsFromArray } from "types/commons";
import { GetListPaymentTermsDocument, GetListPaymentTermsQuery } from "__generated__/view/paymentterms/graphql/queries.generated";

type BaseOption = ChildPropsFromArray<GetListPaymentTermsQuery, "listPaymentTerms">;

export type PaymentTermSelectOption = Omit<BaseOption, "externalReference" | "isDefault"> & {
	externalReference?: string | null;
	locationGroups?: boolean | null;
};

const PaymentTermSelect = ({ ...rest }: Omit<SelectProps<PaymentTermSelectOption, false>, "fetchOptions">) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {
		try  {
			const result = await client.query({
				query: GetListPaymentTermsDocument,
			});

			const options = result.data.listPaymentTerms || [];

			return {
				options: options,
				totalResults: options.length,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={option => `${option.externalReference} (${option.days} ${intl.formatMessage({ id: "DAYS" })})`} />
	);
};

export default PaymentTermSelect;
